import { useEffect, useState } from 'react'
import { useAppStore } from '../stores/app-store'

export function MetricsCard() {
  const { status, iteration, maxIterationsRunning, startTime } = useAppStore()
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    if (!startTime) {
      return
    }

    const interval = setInterval(() => {
      setElapsed(Date.now() - startTime)
    }, 1000)

    return () => clearInterval(interval)
  }, [startTime])

  const formatTime = (ms: number): string => {
    const s = Math.floor(ms / 1000)
    const m = Math.floor(s / 60)
    const sec = s % 60
    return `${m}:${sec.toString().padStart(2, '0')}`
  }

  const progress = maxIterationsRunning > 0 ? (iteration / maxIterationsRunning) * 100 : 0
  const isActive = status === 'running' || status === 'generating-prd' || status === 'publishing'

  if (status === 'idle' && iteration === 0) {
    return null
  }

  return (
    <div className="card metrics-card">
      <div className="card-header">
        <span className="card-title">Metrics</span>
      </div>

      <div className="metrics-grid">
        <div className="metric">
          <span className="metric-label">Iteration</span>
          <span className={`metric-value ${isActive ? 'accent' : ''}`}>
            {iteration}
          </span>
          <span className="metric-sub">of {maxIterationsRunning}</span>
        </div>

        <div className="metric">
          <span className="metric-label">Elapsed</span>
          <span className="metric-value">
            {formatTime(elapsed)}
          </span>
          <span className="metric-sub">{isActive ? 'running' : status}</span>
        </div>

        <div className="progress-bar-wide">
          <div className="progress-labels">
            <span>Progress</span>
            <span>{Math.round(progress)}%</span>
          </div>
          <div className="progress-track">
            <div className="progress-fill" style={{ width: `${progress}%` }} />
          </div>
        </div>
      </div>
    </div>
  )
}
